import { Injectable } from '@angular/core';
import { INavData } from '@coreui/angular';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService } from './admin/authentication.service';
import { managementNavBaseItems } from '../config/sidebar/management-nav-base-items.config';
import { configurationNavBaseItems } from '../config/sidebar/configuration-nav-base-items.config';
import { administrationNavBaseItems } from '../config/sidebar/administration-nav-base-items.config';
import { ApiBugReportsService } from './bug-reports/api/api-bug-reports.service';
import { ApplicationsService } from './applications/applications.service';

@Injectable({
  providedIn: 'root'
})
export class GameSidebarService {

    public sidebarNavItems: INavData[] = [];

    public sidebarNavItemsSubject = new Subject<INavData[]>();

    private currentAdminUserLoggedSubscription: Subscription;

    constructor(
      private authenticationService: AuthenticationService,
      private apiBugReportsService: ApiBugReportsService,
      private applicationsService: ApplicationsService
    ) {
        this.currentAdminUserLoggedSubscription = this.authenticationService.currentAdminUserLoggedSubject.subscribe(
        () => {
            this.refreshSidebarNavItems();
        });

        this.applicationsService.applicationIdSelectedSubject.subscribe(
        () => {
            this.refreshSidebarNavItems();
        });

        this.refreshSidebarNavItems();
    }

    public getSidebarItems() : INavData[] {
        return this.sidebarNavItems;
    }

    private async refreshSidebarNavItems() {
        this.resetSidebarNavItems();

        // Add the basic nav items
        this.addSidebarNavItems(managementNavBaseItems);
        this.addSidebarNavItems(configurationNavBaseItems);
        this.addSidebarNavItems(administrationNavBaseItems);

        this.setBugReportsBadge('');

        try {
            const response = await this.apiBugReportsService.getReportsOpenCount();
            if (response.openCount > 0) {
                this.setBugReportsBadge(response.openCount.toString());
            }
        } catch {
            // Badge update is non-critical, ignore errors
        }

        this.emitSidebarNavItems();
    }

    private emitSidebarNavItems() {
        this.sidebarNavItemsSubject.next(this.sidebarNavItems);
    }

    private resetSidebarNavItems() {
        this.sidebarNavItems = [];
    }

    private addSidebarNavItems(navItems: INavData[]) {
        this.sidebarNavItems = this.sidebarNavItems.concat(navItems);
    }

    private setBugReportsBadge(text: string) {
        for (const item of this.sidebarNavItems) {
            if (item.children && item.children.length > 0) {
                for (const child of item.children) {
                    if (child.class === 'bug-reports' && child.badge) {
                        child.badge.text = text;
                    }
                }
            }
        }
    }
}
